// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"610585ec","369":"1537295a","441":"3fa310c3","453":"082eee73","455":"27955665","534":"8aef0ccb","957":"aa63f38c","981":"82c0189b"}[chunkId] + ".chunk.js";
};